




























































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { inactive, active, approve, getList, UserData } from '@/api/systemManage/user'
import { DDLItem, getCitysByUser, DefDDLItem, getUserTypes } from '@/api/common/select'
import { exportUserList, exportTips } from '@/api/common/export'
import { enFirstType } from '@/configs/enums'
import { getDDLName, getSubDDL, copyArray, toDefaultStr, toDefaultInt, tryToStr, tryToInt, jsonStoreage } from '@/configs/functions'
import PageList from '@/components/pageLayout/list.vue'

import { PagePermissionState, PermissionData, FailedPermission } from '@/store/modules/pagePermission'
import { namespace } from 'vuex-class'
const UserModule = namespace('user')
const PagePermissionModule = namespace('pagePermission')
const DataSourceModule = namespace('dataSource')

@Component({
  components: { PageList }
})
export default class UserList extends Vue {
  public showMore: boolean = false
  @PagePermissionModule.Getter("pagePermission")
  public pagePermission!: PagePermissionState
  public btnCtrl: PermissionData = FailedPermission
  public pagePath: string = ''
  public getPermission() {
    const s = this.pagePermission
    let p = FailedPermission
    let path = ''
    if (this.$route.path.indexOf(s.pagePath) > -1) {
      p = s.permission
      path = s.pagePath
    }
    this.btnCtrl = p
    this.pagePath = path
    var cacheQuery = jsonStoreage.getFilter(path)
    if (cacheQuery && cacheQuery != null) {
      this.queryTerm = Object.assign({}, cacheQuery)
      jsonStoreage.removeFilter(path)
    }
    else {
      this.getQueryTerm()
    }
  }
  @UserModule.Getter("userInfo")
  public curUser!: UserData
  public get userType(): number {
    return this.curUser.UserType
  }
  public get curUserId(): number {
    return this.curUser.Id
  }
  public userTypeName(userType: number): string {
    return getDDLName(this.userTypeList, userType)
  }

  public firstType: number = enFirstType.All
  public defItem: DDLItem = DefDDLItem(this.firstType)
  public list: any = []
  public userTypeList: DDLItem[] = []
  public cityList: DDLItem[] = []
  public countyList: DDLItem[] = [this.defItem]
  public townshipList: DDLItem[] = [this.defItem]
  public approveStatusList: any[] = [
    this.defItem,
    { Key: 1, Val: '已审核' },
    { Key: 2, Val: '未审核' }
  ]
  public activeList: any[] = [
    this.defItem,
    { Key: 1, Val: '已启用' },
    { Key: 2, Val: '已停用' }
  ]
  public transferList: any[] = [
    this.defItem,
    { Key: 1, Val: '在岗' },
    { Key: 2, Val: '已转岗' }
  ]
  public listLoading: boolean = true
  public totalItems: number = 0
  public totalPages: number = 0
  public pageSize: number = window.baseConfig.PageSize
  // 选中项,这里存的是整个行的数据
  public selectedRows = []
  // 查询项
  public queryTerm = {
    Page: 1,
    PageSize: this.pageSize,
    SortBy: 'UpdateDate',
    IsAsc: false,
    UserType: 0,
    RoleId: 0,
    CityId: 0,
    CountyId: 0,
    TownshipId: 0,
    ApplyUnitId: 0,
    Inactive: 1,
    IsApproved: 0,
    IsTransfer: 0,
    Keyword: ''
  }
  // 保存最新的一次查询参数，用来保证分页，排序，导出时保证查询条件不变
  public lastQuery = Object.assign({}, this.queryTerm)
  public getQueryTerm() {
    const query = this.$route.query
    // 从页面Url中获取参数
    this.queryTerm = {
      PageSize: toDefaultInt(query['PageSize'], this.pageSize),
      Page: toDefaultInt(query['Page'], 1),
      SortBy: toDefaultStr(query['SortBy'], 'UpdateDate'),
      IsAsc: tryToStr(query['IsAsc']) == 'true',
      UserType: tryToInt(query['UserType']),
      RoleId: tryToInt(query['RoleId']),
      CityId: tryToInt(query['CityId']),
      CountyId: tryToInt(query['CountyId']),
      TownshipId: tryToInt(query['TownshipId']),
      ApplyUnitId: tryToInt(query['ApplyUnitId']),
      Inactive: toDefaultInt(query['Inactive'], 1),
      IsApproved: tryToInt(query['IsApproved']),
      IsTransfer: tryToInt(query['IsTransfer']),
      Keyword: tryToStr(query['Keyword'])
    }
  }
  // 设置初始排序,无排序可以删掉
  get tableSort() {
    return {
      prop: this.queryTerm.SortBy,
      order: this.queryTerm.IsAsc ? 'ascending' : 'descending'
    }
  }
  // 多选的时候，用到，返回选中的行，这里存的是数组
  public selectedChange(val: never[]) {
    this.selectedRows = val
  }
  // 点击排序按钮的时候，按新排序查询数据
  public sortChange(col: { [key: string]: string }) {
    const query = this.lastQuery
    const asc = col.order === 'ascending' // descending
    if (query.SortBy !== col.prop || query.IsAsc !== asc) {
      query.SortBy = col.prop
      query.IsAsc = asc
      this.refreshData()
    }
  }
  // 分页按钮点击的时候，按新分页查询数据
  public pageEvent() {
    const qt = this.queryTerm
    const query = this.lastQuery
    query.Page = qt.Page
    query.PageSize = qt.PageSize
    this.refreshData()
  }
  // 点击查询按钮时，页码需要重置为1
  public doSearch() {
    this.queryTerm.Page = 1
    this.fetchData(this.queryTerm)
  }
  public created() {
    this.getPermission()
    this.fetchSource()
  }
  // 页面加载事件=pageload
  public mounted() {
    this.doSearch()
  }
  @DataSourceModule.Getter('cityList')
  public cityCounty!: any
  @DataSourceModule.Getter('dataSource')
  public dataSource!: any
  public fetchSource() {
    var cityCounty = copyArray(this.cityCounty)
    if (cityCounty) {
      this.cityList = cityCounty
      if (cityCounty.length == 2) {
        this.queryTerm.CityId = cityCounty[1].Key
      }
      if (this.queryTerm.CityId > 0) {
        this.cityChange(0)
      }
      if (this.queryTerm.CountyId > 0) {
        this.countyChange(0)
      }
    }
    const data = Object.assign({}, this.dataSource)
    if (data) {
      this.userTypeList = data.userTypeList
    }
  }
  public cityChange(reset: number) {
    const qt = this.queryTerm
    this.countyList = [this.defItem]
    if (reset === 1) {
      qt.CountyId = 0
    }
    if (qt.CityId > 0) {
      this.countyList = getSubDDL(this.cityList, qt.CityId)
      if (this.countyList.length == 1) {
        qt.CountyId = this.countyList[0].Key
      }
    }
  }
  public countyChange(reset: number) {
    const qt = this.queryTerm
    this.townshipList = [this.defItem]
    if (reset === 1) {
      qt.TownshipId = 0
    }
    if (qt.CountyId > 0) {
      this.townshipList = getSubDDL(this.countyList, qt.CountyId)
      if (this.townshipList.length == 1) {
        qt.TownshipId = this.townshipList[0].Key
      }
    }
  }
  // 连接后台api查询
  public fetchData(query: any) {
    const qt = query
    qt.ApplyUnitId = qt.TownshipId > 0 ? qt.TownshipId : (qt.CountyId > 0 ? qt.CountyId : qt.CityId)
    this.listLoading = true
    getList(qt).then((response: { data: any }) => {
      const data = response.data
      if (data) {
        this.list = data.Results
        this.totalPages = data.TotalPages
        this.totalItems = data.TotalCount

        this.queryTerm.PageSize = data.PageSize
        this.queryTerm.Page = query.Page
        this.queryTerm.SortBy = query.SortBy
        this.queryTerm.IsAsc = query.IsAsc

        this.lastQuery = Object.assign({}, query)
        jsonStoreage.setFilter(this.pagePath, query)
      }
      this.listLoading = false
    })
  }
  public refreshData() {
    this.fetchData(this.lastQuery)
  }
  // 在当前路由改变，但是该组件被复用时调用
  @Watch('$route')
  public onRouteChange(route: any) {
    this.getPermission()
    const qt = this.queryTerm
    if (qt.CityId > 0) {
      this.cityChange(0)
    }
    if (qt.CountyId > 0) {
      this.countyChange(0)
    }
    this.doSearch()
  }

  public doExport() {
    exportTips(this.$notify, 'excel')
    // 克隆参数
    const qt = Object.assign({}, this.lastQuery)
    exportUserList('用户列表', qt)
  }
  public doAdd() {
    this.$router.push({ path: `/User/New` })
  }
  public doEdit(id: number) {
    this.$router.push({ path: `/User/Edit/${id}` })
  }
  public doTransfer(id: number) {
    this.$confirm(`转岗后该用户将不可使用，并且其未巡查的任务会自动清理掉，确定要转岗吗?`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.$router.push({ path: `/User/Transfer/${id}` })
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '已取消操作'
      })
    })
  }
  public doInactice(id: number) {
    this.$confirm(`确定要停用该用户吗?`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      inactive(id).then(() => {
        this.$message({ type: 'success', message: '用户已停用!' })
        this.refreshData()
      })
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '已取消操作'
      })
    })
  }
  public doActive(id: number) {
    this.$confirm(`确定要启用该用户吗?`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      active(id).then(() => {
        this.$message({ type: 'success', message: '启用成功!' });
        this.refreshData()
      })
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '已取消操作'
      })
    })
  }
  public doApprove(id: number) {
    this.$confirm(`确定要该用户审核通过吗?`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      approve(id).then(() => {
        this.$message({ type: 'success', message: '审核成功!' })
        this.refreshData()
      })
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '已取消操作'
      })
    })
  }
}
